import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { supabase } from '../lib/supabase';
import SeoMeta from '../components/SeoMeta';
import FinalistShareCard from '../components/FinalistShareCard';

const TYPE_ORDER: Record<string, number> = { project: 0, personal: 1, benchmark: 2 };
const isLatam = (name: string) => name.toUpperCase().includes('LATAM');

const FinalistFrame: React.FC = () => {
  const [categories, setCategories] = useState<string[]>([]);

  // Cargamos el listado real de categorías para el desplegable.
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data } = await supabase.schema('premios').rpc('get_public_nominations');
      if (cancelled || !data) return;
      const seen = new Map<string, { type: string }>();
      (data as { category_name: string; category_type: string }[]).forEach((n) => {
        if (!seen.has(n.category_name)) seen.set(n.category_name, { type: n.category_type });
      });
      const sorted = Array.from(seen.entries())
        .sort(([nameA, a], [nameB, b]) => {
          if (TYPE_ORDER[a.type] !== TYPE_ORDER[b.type]) return TYPE_ORDER[a.type] - TYPE_ORDER[b.type];
          const la = isLatam(nameA);
          const lb = isLatam(nameB);
          if (la !== lb) return la ? 1 : -1;
          return nameA.localeCompare(nameB);
        })
        .map(([catName]) => catName);
      setCategories(sorted);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="informe-page">
      <SeoMeta
        title="¿Eres finalista? · Crea tu imagen para compartir · Premios NovaGob"
        description="Si eres finalista de los Premios NovaGob Excelencia 2026, sube tu foto y genera tu propia imagen para compartir en redes sociales."
        path="/soy-finalista"
      />
      <header className="informe-page-header">
        <Link to="/" className="informe-page-back">
          <ArrowLeft size={18} /> Volver
        </Link>
        <span className="informe-page-title">¿Eres finalista?</span>
        <Link to="/" className="informe-page-home">
          Volver al inicio
        </Link>
      </header>

      <div className="informe-page-content" style={{ maxWidth: 1000 }}>
        <p style={{ textAlign: 'center', color: 'var(--color-text-secondary)', marginBottom: 24 }}>
          Si eres finalista de esta edición, crea aquí tu imagen personalizada y compártela en tus redes con el
          #PremiosNovaGob2026
        </p>

        <FinalistShareCard pillText="FINALISTA" categories={categories} fileSuffix="finalista" />
      </div>
    </div>
  );
};

export default FinalistFrame;
